import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const HOSPITAL_MODULES = [
  ["/ingreso_hospitalario", "/ingreso_hospitalario_detalles"],
  ["/informacion_medica", "/informacion_medica_detalles"],
  ["/actualizacion_tramite", "/actualizacion_tramite_detalles"],
  ["/alta_paciente", "/alta_paciente_detalles"],
  ["/consulta_general", "/consulta_general_detalles"],
];

const matchesPrefix = (pathname, prefix) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

export function ZurichDisclaimerBanner() {
  const [open, setOpen] = useState(true);
  const location = useLocation();

  const currentModuleIndex = HOSPITAL_MODULES.findIndex((prefixes) =>
    prefixes.some((p) => matchesPrefix(location.pathname, p))
  );

  // Reabrir el aviso cada vez que el usuario entra a un modulo Hospital distinto.
  useEffect(() => {
    if (currentModuleIndex >= 0) setOpen(true);
  }, [currentModuleIndex]);

  if (currentModuleIndex < 0 || !open) return null;

  return (
    <div style={styles.wrapper} role="status" aria-live="polite">
      <div style={styles.banner}>
        <span style={styles.text}>
          Este Portal está destinado exclusivamente para Asegurados de Zurich
        </span>
        <button
          type="button"
          onClick={() => setOpen(false)}
          aria-label="Cerrar aviso"
          style={styles.closeBtn}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.6)}
        >
          ×
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    padding: "0 16px 12px",
    pointerEvents: "none",
    zIndex: 1030,
  },
  banner: {
    pointerEvents: "auto",
    backgroundColor: "rgba(43, 115, 194, 0.92)",
    backdropFilter: "blur(2px)",
    WebkitBackdropFilter: "blur(2px)",
    color: "#ffffff",
    padding: "10px 20px",
    borderRadius: "8px",
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.08)",
    display: "flex",
    alignItems: "center",
    gap: "16px",
    maxWidth: "900px",
    width: "100%",
    fontWeight: 500,
    fontSize: "14px",
    letterSpacing: "0.2px",
  },
  text: {
    flex: 1,
    textAlign: "center",
  },
  closeBtn: {
    background: "transparent",
    border: "none",
    color: "#ffffff",
    fontSize: "20px",
    lineHeight: 1,
    cursor: "pointer",
    padding: "0 4px",
    opacity: 0.6,
    transition: "opacity 120ms ease",
  },
};

export default ZurichDisclaimerBanner;
